import React from 'react';
import {
  HorizontalCardCustomContent,
  HorizontalCardDropdownButton,
  HorizontalCardIconButton,
  HorizontalCardProps,
  HorizontalCardToggleButton
} from './types';
import {IconButton} from '../../Button';
import {ToggleButton} from '../../Toggles';
import {DropdownButton} from '../../Dropdown';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
`;

type Props = Pick<HorizontalCardProps, 'actions' | 'disabled'>;

export const HorizontalCardActions = React.forwardRef(({actions, disabled}: Props,
                                                       ref: React.Ref<React.RefObject<HTMLButtonElement | null>[]>) => {

  const [elRefs, setElRefs] = React.useState<React.RefObject<HTMLButtonElement | null>[]>([]);
  const length = actions?.length || 0;

  React.useEffect(() => {
    setElRefs(Array(length || 0).fill(null).map(() => React.createRef<HTMLButtonElement>()));
  }, [length]);

  React.useImperativeHandle(ref, () => elRefs, [elRefs]);

  const renderAction = (item: HorizontalCardIconButton | HorizontalCardToggleButton | HorizontalCardDropdownButton | HorizontalCardCustomContent,
                        index: number) => {
    switch (item.componentType) {
      case 'custom': {
        return item.content
      }
      case 'icon': {
        return <IconButton ref={elRefs[index]}
                           key={index}
                           variant={'secondary'}
                           useTransparentBackground={true}
                           shape={'circular'}
                           action={item.action}
                           tooltip={item.tooltip}
                           disabled={item.disabled ?? disabled}>
          {item.icon}
        </IconButton>
      }
      case 'toggle': {
        return <ToggleButton ref={elRefs[index]}
                             key={index}
                             active={item.active}
                             onChange={item.onChange}
                             defaultState={item.defaultState}
                             activeState={item.activeState}
                             disabled={item.disabled ?? disabled}/>
      }
      case 'dropdown': {
        return <DropdownButton ref={elRefs[index]}
                               key={index}
                               type={'icon'}
                               items={item.items}
                               itemsType={item.itemsType}
                               onClick={item.onClick}
                               icon={item.icon}
                               action={item.action}
                               actionIcon={item.actionIcon}
                               actionLabel={item.actionLabel}
                               actionVariant={item.actionVariant}
                               actionLoading={item.actionLoading}
                               multiSelect={item.multiSelect}
                               scrollable={item.scrollable}
                               pinTopItem={item.pinTopItem}
                               maxHeight={item.maxHeight}
                               disabled={item.disabled ?? disabled}/>
      }
    }
  }


  return (
    <>
      {
        actions?.length &&
        <Container>
          {actions?.map((item, index) => renderAction(item, index))}
        </Container>
      }
    </>
  )
});
